export interface ProcessTaskIdsContext {
  taskIds: Array<string>;
}

export type OutsideNotebookContext = ProcessTaskIdsContext | {};

export function isProcessTaskIdsContext(
  outsideNotebookContext: OutsideNotebookContext
): outsideNotebookContext is ProcessTaskIdsContext {
  return (outsideNotebookContext as ProcessTaskIdsContext).taskIds != null;
}
